export const BACKGROUND_HEADER = 'x-background-request';
export const USER_ACTIVE_WINDOW_MS = 10000;
export const SESSION_HEARTBEAT_MS = 60000;
// A deadline check that could not reach the API (offline, 5xx) is tried again after this long.
export const SESSION_RECHECK_MS = 15000;
export const SESSION_CHANNEL = 'tav-session';
export const PROOF_HEADER = 'x-session-proof';
export const SERVER_TIME_HEADER = 'x-server-time';
export const EXPIRES_IN_HEADER = 'x-session-expires-in';
export const ABSOLUTE_EXPIRES_IN_HEADER = 'x-session-absolute-expires-in';
export const PROOF_TYP = 'tav-proof+jwt';
export const PROOF_ALG = 'ES256';
export const KEY_DB_NAME = 'tav-session';
export const KEY_STORE_NAME = 'keys';
export const CURRENT_KEY_ID = 'current';
export const SESSION_KEY_LOCK = 'tav-session-key';
// Without Web Locks, a proof-invalid failure waits this long for another tab's commit before re-reading the key.
export const KEY_REREAD_DELAY_MS = 300;
export const MS_PER_SECOND = 1000;
export const SECONDS_PER_MINUTE = 60;
export const SECONDS_PER_HOUR = 3600;
export const JTI_BYTES = 16;
// Broadcasting the expiry on every response would flood the channel; other tabs only need it now and then.
export const EXPIRY_BROADCAST_INTERVAL_MS = 5000;
export const FOREGROUND_BROADCAST_INTERVAL_MS = 5000;
export const UNSUPPORTED_BROWSER_MESSAGE =
  "This browser can't keep your sign-in secure. Please update your browser, or allow this site to store data, then try again.";
